import fetch from '../../utils/fetch'

// 查询物业管理公司  列表
export function listSyscompany() {
    return fetch({
        url: '/api/syscompany/list',
        method: 'get',
    })
}

// 查询停车场  列表
export function listParkinfo(query) {
    return fetch({
        url: '/api/parkinfo/list',
        method: 'get',
        params: query
    })
}

// 查询固定车收费规则
export function getFeescalFixation(query) {
    return fetch({
        url: '/api/feescalFixation/getFeescalFixation',
        method: 'get',
        params: query
    })
}

// 查询用户主车牌及子车牌
export function getUserSlaveList(query) {
    return fetch({
        url: '/api/feescalFixation/getPlateinfoAndSlaveList',
        method: 'get',
        params: query
    })
}

// 查询商户车牌组
export function getBusinessPlateinfoList(query) {
    return fetch({
        url: '/api/feescalFixation/getBusinessPlateinfoList',
        method: 'get',
        params: query
    })
}

//缴费
export function payParkingFee(params) {
    return fetch({
        url: '/api/feescalFixation/payParkingFee',
        method: 'post',
        data: params
    })
}
